import { FirstSection } from "../Home/FirstSection/FirstSection"
import { Instituciones } from "../Home/Instituciones/Instituciones"
import Pdf from "../../assets/svg/pdf.svg";
import Enlace from "../../assets/svg/enlace.svg";
import { useCapacitacion } from "../../hooks/useCapacitacion";
import { Fragment, useEffect } from "react";
import { pathPDF } from "../../routes/endpoints";

export const Capacitacion = () => {
    const { introduccion, archivos, getIntroduccion, getArchivos } = useCapacitacion();

    useEffect(() => {
        getIntroduccion();
        getArchivos();
    }, [])


    return (
        <div>
            <FirstSection />
            <div className="container-fluid py-3">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        {introduccion?.length &&
                            <>
                                <h1 className="mt-3" style={{ fontSize: 25 }}>{introduccion?.[0].titulo}</h1>
                                <p className="p-4">{introduccion?.[0].introduccion}</p>
                            </>

                        }
                    </div>
                    {archivos?.map(({ pdf, titulo, url }, i) => (
                        <Fragment key={i} >
                            {pdf &&
                            <div className="col-lg-2 col-md-4 col-9">
                                <a className="bg-gris2" aria-expanded="false" href={`${pathPDF}${pdf}`} target="_blank">
                                    <img src={Pdf} className="iconos-capacitacion" alt="" />
                                    <p className="titulo-navegadores">{titulo}</p>
                                </a>
                            </div>
                            }
                            {url && 
                            <div className="col-lg-2 col-md-4 col-9">
                                <a className="bg-gris2" aria-expanded="false" href={url} target="_blank">
                                    <img src={Enlace} className="iconos-capacitacion" alt="" />
                                    <p className="titulo-navegadores">{titulo}</p>
                                </a>
                            </div>
                            }
                        </Fragment>
                    ))}

                </div>
            </div>
            <Instituciones />
        </div>
    )
}
